// Pure long-press charge curve: how full (0→1) the hold ring is at `elapsed` ms
// into a press that commits at `hold` ms. Kept pure & unit-tested — like
// speed.ts — so the gesture's feel lives in one defined place.
export function pressMeterAt(elapsed: number, hold: number): number {
  if (hold <= 0) return 1;
  if (elapsed <= 0) return 0;
  if (elapsed >= hold) return 1;
  return elapsed / hold;
}
